import React from "react";
import aboutBanner from "../../assets/images/about/aboutBanner.png";
import storyImg from "../../assets/images/about/story.png";
import missionImg from "../../assets/images/about/mission.png";
import visionImg from "../../assets/images/about/vision.png";
import diverseImg from "../../assets/images/about/diverse.png";
import customizationImg from "../../assets/images/about/customization.png";
import handcraftImg from "../../assets/images/about/handcraft.png";
import virtualImg from "../../assets/images/about/virtual.png";
import footwearImg from "../../assets/images/about/footwear.png";
import commitmentImg from "../../assets/images/about/commitment.png";
import { Link } from "react-router-dom";

export function About() {
  return (
    <div className="HomeMainContainer container">
      <div className="aboutBanner">
        <div>
          <div className="aboutTitle">About Us</div>
          <div className="aboutDesc">
            Srimy is your ultimate fashion destination, offering stylish
            clothing and accessories for every occasion
          </div>
        </div>
      </div>
      {/* categories section */}
      <div>
        <div className="storyContainer">
          <div className="story-left">
            <img src={storyImg} />
          </div>
          <div className="story-right">
            <div className="story-title">Our Story</div>
            <div className="story-desc">
              Founded with a vision to bring elegance and comfort together,
              Srimy has grown to become a trusted name in the fashion industry.
              Our journey began with a simple idea: to offer beautifully crafted
              clothing that reflects individuality and style. Today, we pride
              ourselves on our diverse collection and exceptional customer
              service.
            </div>
            <div className="btnAboutContact">
              <Link to="/contact">
                {" "}
                <button>Contact Us</button>
              </Link>
            </div>
          </div>
        </div>

        <div className="missionContainer">
          <div className="mission-left">
            <div className="mission-title">Our Mission</div>
            <div className="mission-desc">
              Our mission is to empower individuals to express themselves
              through fashion. We strive to offer a seamless shopping
              experience, providing a wide range of options that cater to every
              taste and preference. We are committed to delivering quality
              products that make our customers look and feel their best.
            </div>
            <div className="btnAboutContact">
              <Link to="/contact">
                {" "}
                <button>Contact Us</button>
              </Link>
            </div>
          </div>
          <div className="mission-right">
            <img src={missionImg} />
          </div>
        </div>

        <div className="storyContainer">
          <div className="story-left">
            <img src={visionImg} />
          </div>
          <div className="story-right">
            <div className="story-title">Our Vision</div>
            <div className="story-desc">
              At Srimy, we envision a world where everyone can embrace their
              unique style with confidence. We aim to be the go-to fashion
              destination, known for our innovative designs, superior quality,
              and personalized customer experience. Our vision is to inspire and
              elevate fashion standards globally.
            </div>
            <div className="btnAboutContact">
              <Link to="/contact">
                {" "}
                <button>Contact Us</button>
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* what we offer */}
      <div className="offerContainer">
        <div className="offer-maintitle">What We Offer</div>
        <div className="offer-subContainer">
          <div className="offerImg">
            <img src={diverseImg} />
          </div>
          <div>
            <div className="offer-title">Diverse Clothing Options</div>
            <div className="offer-desc">
              From formal and casual wear to exquisite bridal dresses, we have
              it all. Our collection is designed to suit various styles and
              occasions.
            </div>
          </div>
        </div>
        <div className="offer-subContainer">
          <div className="offerImg">
            <img src={customizationImg} />
          </div>
          <div>
            <div className="offer-title">Customization & Tailoring</div>
            <div className="offer-desc">
              We understand that everyone is unique. Our customization and
              tailoring services ensure that your clothing fits perfectly and
              reflects your personal style.
            </div>
          </div>
        </div>
        <div className="offer-subContainer">
          <div className="offerImg">
            <img src={handcraftImg} />
          </div>
          <div>
            <div className="offer-title">Handcrafted Jewelry</div>
            <div className="offer-desc">
              Complement your outfits with our stunning handcrafted jewelry.
              Each piece is crafted with care and attention to detail.
            </div>
          </div>
        </div>
        <div className="offer-subContainer">
          <div className="offerImg">
            <img src={virtualImg} />
          </div>
          <div>
            <div className="offer-title">Virtual Styling Sessions</div>
            <div className="offer-desc">
              Need help putting together the perfect look? Our virtual styling
              sessions provide personalized fashion advice from the comfort of
              your home.
            </div>
          </div>
        </div>
        <div className="offer-subContainer">
          <div className="offerImg">
            <img src={footwearImg} />
          </div>
          <div>
            <div className="offer-title">Footwear</div>
            <div className="offer-desc">
              Complete your ensemble with our stylish and comfortable footwear
              collection. We offer a variety of options to match every outfit.
            </div>
          </div>
        </div>
      </div>
      {/* our commitment */}

      <div className="ourCommitment-container">
        <div className="missionContainer">
          <div className="mission-left">
            <div className="mission-title">Our Commitment</div>
            <div className="mission-desc">
              We are committed to sustainability and ethical practices. We
              source our materials responsibly and ensure that our manufacturing
              processes are environmentally friendly. Our dedication to quality
              and customer satisfaction drives us to continually improve and
              innovate.
            </div>
            <div className="btnAboutContact">
              <Link to="/contact">
                {" "}
                <button>Contact Us</button>
              </Link>
            </div>
          </div>
          <div className="mission-right">
            <img src={commitmentImg} />
          </div>
        </div>
      </div>
    </div>
  );
}
